import { axios, API } from './config';

export const eventsAPI = {
  getAll: async (eventType = null, date = null) => {
    const params = {};
    if (eventType) params.event_type = eventType;
    if (date) params.date = date;
    const response = await axios.get(`${API}/events`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/events/${id}`);
    return response.data;
  },
  
  create: async (eventData) => {
    const response = await axios.post(`${API}/events`, eventData);
    return response.data;
  },
  
  update: async (id, eventData) => {
    const response = await axios.put(`${API}/events/${id}`, eventData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/events/${id}`);
    return response.data;
  }
};
